/* DON'T EDIT THIS FILE: edit original and run build again */ import { DocumentHeaderParams } from "../../../framework/tenant-handler-type/onboarding-options.ts";
import { BaseSgrOnboardingOptions } from "../../../framework/tenant-handlers/base-sgr-onboarding-options.ts";
import {
  AFIP,
  EMAIL,
} from "../../../onboarding/signatura-document-validations/document-validations.ts";
import { FunctionComponent } from "react";

class ArgenpymesOnboardingOptions extends BaseSgrOnboardingOptions {
  hasSignatura(): boolean {
    return true;
  }

  hasRevenueVolume(): boolean {
    return false;
  }

  getSignaturaValidations(): string[] {
    return [EMAIL, AFIP];
  }

  hasSwornStatement(): boolean {
    return true;
  }

  async getDocumentHeader(): Promise<FunctionComponent<DocumentHeaderParams>> {
    return (await import("../../../framework/dependency/forbidden-import.front.ts")).default;
  }

  useSnailMailViaEmail(): boolean {
    return false;
  }

  getEmailAfterLabelText(): string | null {
    return null;
  }

  getOpenAccountAgreementLabel(): string {
    return 'Identificación del "Socio participe / tercero MIPyME"';
  }

  hasPositionFieldRequired(): boolean {
    return true;
  }

  hasTerms(): boolean {
    return false;
  }

  getInvestmentProfileMethod(): "manual" | "score" | "none" {
    return "manual";
  }
}

export const argenpymesOnboardingOptions = new ArgenpymesOnboardingOptions();
